var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 7.5H5.75C5.55109 7.5 5.36032 7.42098 5.21967 7.28033C5.07902 7.13968 5 6.94891 5 6.75C5 6.55109 5.07902 6.36032 5.21967 6.21967C5.36032 6.07902 5.55109 6 5.75 6H14.75C14.9489 6 15.1397 6.07902 15.2803 6.21967C15.421 6.36032 15.5 6.55109 15.5 6.75C15.5 6.94891 15.421 7.13968 15.2803 7.28033C15.1397 7.42098 14.9489 7.5 14.75 7.5ZM14.75 12H5.75C5.55109 12 5.36032 11.921 5.21967 11.7803C5.07902 11.6397 5 11.4489 5 11.25C5 11.0511 5.07902 10.8603 5.21967 10.7197C5.36032 10.579 5.55109 10.5 5.75 10.5H14.75C14.9489 10.5 15.1397 10.579 15.2803 10.7197C15.421 10.8603 15.5 11.0511 15.5 11.25C15.5 11.4489 15.421 11.6397 15.2803 11.7803C15.1397 11.921 14.9489 12 14.75 12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquals);
export default __webpack_public_path__ + "static/media/equals.77890ac6c57f0a6311905b9790c2de0e.svg";
export { ForwardRef as ReactComponent };